export function addImportedFromDisplayField({ displayFields }) {
    if (displayFields.some((f) => f.field === "importedFrom")) return
    displayFields.push({
        field: "importedFrom",
        label: "Source File",
    })
}
